import React from 'react';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';

// Imported directly instead of via '../../components': TrustSeals is rendered
// by TrustSealsBanner inside LayoutSingleColumn, which most of the barrel
// file's exports pull in.
import ExternalLink from '../ExternalLink/ExternalLink';
import ReviewWidget from '../ReviewWidget/ReviewWidget';

import guetesiegelImage from './images/konsumentenbund-guetesiegel.webp';
import certifiedImage from './images/konsumentenbund-certified.webp';
import css from './TrustSeals.module.css';

// toastably's profile on the issuer's own site — the page that substantiates
// the certification. Also used by TrustSealsBanner's "learn more" link.
export const KONSUMENTENBUND_PROFILE_URL =
  'https://www.konsumentenbund.ch/kundenversprechen/toastably/';

/**
 * Konsumentenbund trust badges: the Gütesiegel next to the Swiss Consumer
 * Association "certified" seal. With showReviewWidget the static certified
 * seal gives way to the live kundenversprechen.ch review widget, which shows
 * the same seal art plus the stars and review count — the footer and
 * TrustBadgesPanel use that; TrustSealsBanner keeps the image pair.
 *
 * The image badges open the issuer's profile page for toastably in a new
 * tab, so visitors can verify the certification at the source.
 *
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 * @param {boolean?} props.showReviewWidget replace the certified seal image
 *   with the live review widget (stars + count)
 * @param {Function?} props.onWidgetLoad forwarded to the review widget's
 *   iframe onLoad
 */
const TrustSeals = props => {
  const { rootClassName, className, showReviewWidget = false, onWidgetLoad } = props;
  const intl = useIntl();
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <ExternalLink className={css.badgeLink} href={KONSUMENTENBUND_PROFILE_URL}>
        <img
          className={css.badge}
          src={guetesiegelImage}
          width="260"
          height="245"
          loading="lazy"
          alt={intl.formatMessage({ id: 'TrustSeals.sealAlt' })}
        />
      </ExternalLink>
      {showReviewWidget ? (
        <ReviewWidget onLoad={onWidgetLoad} />
      ) : (
        <ExternalLink className={css.badgeLink} href={KONSUMENTENBUND_PROFILE_URL}>
          <img
            className={css.badge}
            src={certifiedImage}
            width="260"
            height="260"
            loading="lazy"
            alt={intl.formatMessage({ id: 'TrustSeals.certifiedAlt' })}
          />
        </ExternalLink>
      )}
    </div>
  );
};

export default TrustSeals;
